import { atomWithReset } from "jotai/utils";

export const isMeasurementModeActiveAtom = atomWithReset(false);
